//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "S2InputSwitch",
  props: {
    disabled: Boolean,
    labelActive: {
      type: String,
      default: "",
    },
    labelDisabled: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    emitValue() {
      !this.disabled && this.$emit("input", !this.value);
    },
  },
};
